import { PEPM_MAX } from "@platform/formatting-utils";

export const COVERAGES = "product";

export const CURRENT_COVERAGES = "clientProducts";

export const CARRIERS = "carriers";

export const CUSTOM_CLIENT_FORM_CONF = {
  CLIENT_EXECUTIVE: "clientExecutive",
  PRACTICE: "practice",
  CORPORATE_ENTITY: "corporateEntity",
  OFFICE: "officeLocation",
  ONEDIGITAL_OFFICE: "onedigitalOffice",
};

export const CLIENT_FORM = {
  CLIENT_ID: "clientId",
  CLIENT_TYPE: "clientType",
  NAME: "name",
  TOTAL_BENEFITS: "numberOfEmployees",
  CLIENT_SINCE: "clientSince",
  SIC: "sic",
  CITY: "city",
  STATE: "state",
  SITUS_STATE: "situsState",
  ZIP_CODE: "zipCode",
  STREET_1: "addressLine1",
  STREET_2: "addressLine2",
  PRODUCER_NAME: "producer",
  PRODUCER_FIRST_NAME: "producerFirstName",
  PRODUCER_LAST_NAME: "producerLastName",
  PRODUCER_EMAIL: "producerEmail",
  ...CUSTOM_CLIENT_FORM_CONF,
};

export const RFP_FORM = {
  ...CLIENT_FORM,
  EFFECTIVE_DATE: "effectiveDate",
  DUE_DATE: "dueDate",
  HAS_BEN_ADMIN_SYSTEM_STATUS: "hasBenAdminSystemStatus",
  REQUESTED_SYSTEM_OTHER: "requestedSystemOther",
  TECH_IMPLEMENTATION: "techImplementation",
  TECH_CREDIT_TYPE: "techCreditType",
  TECH_CREDIT_AMOUNT: "techCreditAmount",
  MARKETING_OBJECTIVES: "marketingObjectives",
  REQUESTED_SYSTEM: "requestedSystem",
  REQUESTED_AMOUNT: "requestedAmount",
  EN_CENSUS_AVAILABLE: "enCensusAvailable",
  EN_CENSUS_FEATURE_ENABLED: "enCensusFeatureEnabled",
  EN_CENSUS_FOR_PROSPECTS: "enCensusForProspects",
  EN_PUSH_SOLD_PLAN_DATA: "enPushSoldPlanData",
  EN_PUSH_SOLD_PLAN_DATA_FEATURE_ENABLED: "enPushSoldPlanDataFeatureEnabled",
};

export const CLIENT_ACTION_VALUES = {
  ...RFP_FORM,
  FORM_INFO: "form",
  CLIENT_ERROR: "clientError",
  IS_RFP_FORM_VALID: "isRfpFormValid",
  IS_NEW_CLIENT: "isNewClient",
  IS_CURRENT_CLIENT: "isCurrentClient",
  PROSPECT_CLIENT_DATA: "prospectClientData",
  CLIENT_DETAIL: "clientDetail",
};

export const COVERAGE_FORM = {
  IS_CURRENT_COVERAGE: "isCurrentCoverage",
  PLAN_TYPE: "planType",
  DUAL_PLAN_TYPE: "dualPlanType",
  PLANS: "plans",
  ENROLLED_LIVES: "enrolledLives",
  CONTRIBUTION_STRUCTURE: "contributionStructure",
  CONTRIBUTION_TYPE: "contributionType",
  CONTRIBUTION_VALUE: "contributionValue",
  FUNDING_ARRANGEMENT: "fundingArrangement",
  CURRENT_COMMISSION: "currentCommission",
  REQUESTED_COMMISSION: "requestedCommission",
  CURRENT_COMMISSION_DETAIL: "currentCommissionDetail",
  REQUESTED_COMMISSION_DETAIL: "requestedCommissionDetail",
  COMMENTS: "comments",
  SINGLE_OPTION: "Single Option",
  DUAL_OPTION: "Dual Option",
  DHMO: "DHMO",
  HMO: "HMO",
  INDEMNITY: "Indemnity",
  PPO: "PPO",
  BASE_BUY_UP_OPTION: "Base / Buy Up",
  TOTAL_EMPLOYER_PAID: "100% Employer Paid",
  TOTAL_EMPLOYEE_PAID: "100% Employee Paid",
  CONTRIBUTORY: "Contributory",
  EMPLOYER_CONTRIBUTION_PERCENTAGE: "Employer Contribution %",
  EMPLOYER_CONTRIBUTION_AMOUNT: "Employer Contribution Amount $",
  FULLY_FUNDED: "Fully Funded",
  ASO: "ASO",
  DUAL_PLAN_1: "Dual Plan 1",
  DUAL_PLAN_2: "Dual Plan 2",
  PPO1_PPO2: "PPO1/PPO2",
  PPO_DHMO: "PPO/DHMO",
  DUAL_OPTION_PPO_1: "Dual Option PPO 1",
  DUAL_OPTION_PPO_2: "Dual Option PPO 2",
  DUAL_OPTION_PPO: "Dual Option PPO",
  DUAL_OPTION_DHMO: "Dual Option DHMO",
  PLAN_1: "Plan 1",
  PLAN_2: "Plan 2",
  ALTERNATIVE_FUNDED: "Alternate Funded",
  ATP: "ATP",
  ATP_TYPE: "ATP Type",
  BEN_CALCS_LABEL: "Ben Calcs",
  BEN_CALCS: "benCalcs",
  CHECK_CUTTING_LABEL: "Check Cutting",
  CHECK_CUTTING: "checkCutting",
  FICA_OPTION: "ficaOption",
  FICA_MATCHING_YES: "Yes",
  FICA_MATCHING_NO: "No",
  FICA_MATCHING_UNKNOWN: "Unknown",
  FICA_BILLABLE: "ficaBillable",
  BILLABLE: "Billable",
  NOT_BILLABLE: "Not Billable",
  SINGLE_OPTION_PPO: "Single Option PPO",
  SINGLE_PLAN: "Single Plan",
  NO_PLAN: "-",
  BASE_BUY_UP: "Base / Buy Up",
  BASE_BUY_PLAN_1: "Base/Buy Up Plan 1",
  BASE_BUY_PLAN_2: "Base/Buy Up Plan 2",
  GROSS_UP: "Gross Up",
  RATE_TYPE: "rateType",
  MONTHLY_PAYROLL: "Per $100 Covered Monthly Payroll",
  MONTHLY_BENEFITS: "Per $100 Covered Monthly Benefit",
  ADA: "americanWithDisabilitiesAct",
  INCLUDED: "Included",
  NOT_INCLUDED: "Not Included",
  ENROLLED_W2_EMPLOYEES_LABEL:
    "Number of W-2 employees confirmed with zip codes",
  ENROLLED_W2_EMPLOYEES: "W-2EmployeesConfirmedWithZipCodes",
  ALTERNATIVE_FUNDED_TYPE: "alternateFundedType",
  PLAN_DESIGN: "planDesign",
  STATES_KEY: "states",
  ALTERNATE_PLANS: "alternatePlans",
  ALTERNATE_PLANS_STRUCTURED: "alternatePlansStructured",
  ADDITIONAL_NOTES: "additionalNotes",
};

export const ERROR_MESSAGES = {
  REQUIRED_FIELD: "This is a required field.",
  REQUIRED_OPTION: "Please select an option.",
  ENROLLED_W2_EMPLOYEES: "Number of W-2 employees confirmed with zip codes",
  ALTERNATIVE_FUNDED_TYPE: "Alternate Funded Type",
  STATES_KEY: "states",
  REQUIRED_STATE: "Select at least one state",
  PRINCIPAL_VALIDATION: "7 digits required starting with ‘1’, e.g. 1123456",
  GUARDIAN_VALIDATION:
    "8 digits required starting with ‘00’ or ‘01’, e.g. 00234567",
  ANTHEM_VALIDATION:
    "6 characters required: the first two can be letters or numbers, followed by four digits, e.g. AB1234, 1C3456 or 157582.",
  PREMIUM_VALIDATION: "Annual Premium may not start with 0",
  CONTRIBUTION_VALUE_VALIDATION:
    "Select Contribution type and enter appropriate value.",
  COMMISSION_AMOUNT_REQUIRED: "Enter an amount for this commission type.",
  COMMISSION_PERCENTAGE_REQUIRED:
    "Enter a percentage for this commission type.",
  COMMISSION_PEPM_MAX: `Enter an amount up to $${PEPM_MAX}.`,
  COMMISSION_HEAPED_PAIR_REQUIRED:
    "Enter both percentages, or leave both empty.",
};

export const COVERAGE_NAMES = {
  VISION: "Vision",
  CANCER: "Cancer Insurance",
  ACCIDENT: "Accident Insurance",
  CI: "Critical Illness Insurance",
  HOSPITAL: "Hospital Indemnity Insurance",
  WHOLE_LIFE: "Whole Life",
  LTD: "Long Term Disability",
  FMLA: "Family Medical Leave Administration",
  BASIC_LIFE: "Basic Life/AD&D",
  VOLUNTARY_LIFE: "Voluntary Life/AD&D",
  STD: "Short Term Disability",
  EAP: "Employee Assistance Program",
  DENTAL: "Dental",
  DENTAL_PPO: "Dental PPO",
  DENTAL_DHMO: "Dental HMO",
  INDIVIDUAL_DISABILITY: "Individual Disability Insurance",
  SDL: "State Disability & Leaves",
};

export const RFP_ACTION_VALUES = {
  STILL_PENDING_DOC: "stillPendingDoc",
  DATA: "data",
  ACTIVE_STEP: "activeStep",
  HIGHER_LAST_STEP: "higherLastStep",
  DOCUMENTS: "documents",
  COVERAGES: "product",
  NEW_COVERAGES: "newProducts",
  CURRENT_COVERAGES: "clientProducts",
  CARRIERS: "carriers",
  STRATEGIC_CARRIERS: "strategicCarriers",
  SELECTED_COVERAGES: "selectedCoverages",
  SELECTED_CARRIERS: "selectedCarriers",
  STEPS: "steps",
  ARE_COVERAGES_VALID: "areCoveragesValid",
  COVERAGE_INDEX: "coverageIndex",
  ID: "id",
  LAST_MODIFIED: "lastModifyDate",
  DOCUMENT_TYPES: "documentTypes",
  ARE_DOCUMENTS_VALID: "areDocumentsValid",
  UPLOADED_FILES: "uploadedFiles",
  ADDITIONAL_DOCUMENTS: "additionalDocuments",
  IS_CENTRO_CARRIER_SELECTED: "centroCarrierSelectionRequested",
  CLIENT_DETAIL: "clientDetail",
};

export const COVERAGE_VALUES = {
  COVERAGE: "coverage",
  SUBTYPES: "subtypes",
  CARRIER: "carrier",
  NEW_CARRIER: "newCarrier",
  EFFECTIVE_DATE: "effectiveDate",
  RENEWAL_DATE: "renewalDate",
  PREMIUM: "premium",
  GROUP_NUMBER: "groupNumber",
};

const {
  COVERAGE,
  SUBTYPES,
  CARRIER,
  NEW_CARRIER,
  EFFECTIVE_DATE,
  RENEWAL_DATE,
  PREMIUM,
  GROUP_NUMBER,
} = COVERAGE_VALUES;

export const modalInitValues = {
  [COVERAGE]: null,
  [SUBTYPES]: null,
  [NEW_CARRIER]: null,
  [CARRIER]: null,
  [EFFECTIVE_DATE]: null,
  [RENEWAL_DATE]: null,
  [PREMIUM]: "",
  [GROUP_NUMBER]: "",
};

export const ANALYST_RFPS_STATUSES = {
  pendingAssignment: "Pending Assignment",
  underReview: "Under Review",
  outToMarket: "Out to Market",
  deliveredPartial: "Delivered Partial",
};

export const MAIN_CARRIERS = {
  PRINCIPAL: "Principal",
  PRINCIPAL_FINANCIAL: "Principal Financial Group",
  GUARDIAN: "Guardian",
  HUMANA: "Humana",
};

export const ANTHEM_CARRIERS = {
  ANTHEM: "Anthem",
  ANTHEM_CA: "Anthem CA",
  ANTHEM_CO: "Anthem CO",
  ANTHEM_CT: "Anthem CT",
  ANTHEM_GA: "Anthem GA",
  ANTHEM_IN: "Anthem IN",
  ANTHEM_KY: "Anthem KY",
  ANTHEM_LIFE_INSURANCE_CO: "Anthem Life Insurance Co.",
  ANTHEM_LUMENOS: "Anthem-Lumenos",
  ANTHEM_ME: "Anthem ME",
  ANTHEM_MO: "Anthem MO",
  ANTHEM_NH: "Anthem NH",
  ANTHEM_NV: "Anthem NV",
  ANTHEM_NY: "Anthem NY",
  ANTHEM_OH: "Anthem OH",
  ANTHEM_VA: "Anthem VA",
  ANTHEM_WI: "Anthem WI",
};

export const CARRIER_GROUP_NUMBER_VALIDATION_PATTERN = {
  PRINCIPAL: /^1\d{6}$/,
  GUARDIAN: /^0[01]\d{6}$/,
  ANTHEM: /^[A-Za-z0-9]{2}\d{4}$/,
};

export const TECH_CREDIT_TYPES = [
  { value: "percentage", label: "Percentage" },
  { value: "dollarAmount", label: "Dollar Amount" },
  { value: "pepm", label: "PEPM" },
  { value: "carrierStandard", label: "Carrier Standard" },
];
